<template>
  <div class="im-header">
    <div class="l-wrap">
      <router-link class="logo" to="/">
        <img src="@/assets/images/username.png" alt="logo" />
        <span class="username">{{ userData.company }}</span>
      </router-link>
      <div class="right">
        <button class="im-button login-out" @click="loginOut">
          安全退出 <em class="iconfont icon-youjiantou"></em>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserToInfo } from "@/api/user";
export default {
  name: "Header",
  data() {
    return {};
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    // 获取用户数据
    // async setUserData() {
    
    //   if (this.userData&&Object.keys(this.userData).length < 1) {
        
    //     const { data: res } = await getUserToInfo();
    //     this.$store.commit("setUserData", res.data);
    //   }

    //   this.loading = false;
    // },
    // 退出登录
    loginOut() {
      localStorage.clear();
      this.$router.push("/login");
      // setTimeout(() => {
      //   location.reload();
      // }, 200);
    },
  },
  created() {
    // this.setUserData();
  },
};
</script>
